<template>
  <div
    class="fixed left-0 top-0 bg-overlay w-full h-full z-65001"
  >
    <div
      v-if="loaded"
      class="bg-white fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg p-4 flex flex-col max-h-screen-h-3/4"
    >
      <div class="uppercase font-medium text-roc-gray text-xl pb-2 border-b border-roc-gray mb-4">
        Museum
      </div>
      <div class="flex flex-row">
        <div class="flex flex-col gap-2 w-64 mr-8">
          <MuseumGroupItem
            v-for="group in groups"
            :key="'group-' + group.id"
            :selected="group.id === selectedGroup"
            :group="group"
            @click="selectGroup"
          />
        </div>
        <div
          class="flex-grow relative w-128"
        >
          <MuseumListItem
            v-for="a in allArtifacts"
            :key="a.id"
            :artifact="a"
            :config="config[a.id]"
            @activate="toggleArtifactActive"
          />
          <div class="clear-both" />
        </div>
      </div>
      <div
        class="flex flex-col py-4 border-t border-gray-100 leading-none mt-4"
      >
        <div class="font-medium flex flex-row items-center">
          Happiness effect:
          {{ happinessEffect.value }}
          <img
            :src="require(`@/assets/images/icon/Culture_Bonus.webp`)"
            alt="Culture bonus"
            style="padding-left: 5px; padding-right: 5px;"
          />
          {{ happinessEffect.range }}
          <img
            :src="require(`@/assets/images/icon/Culture_Range.webp`)"
            alt="Culture range"
            style="padding-left: 5px;"
          />
        </div>
      </div>
      <div class="text-right border-t border-roc-gray w-full pt-4 flex flex-row">
        <button
          class="rounded bg-blue-roc hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer mr-auto"
          @click="toggleAll"
        >
          Toggle all
        </button>
        <button
          class="rounded bg-red-600 hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
          @click="cancel"
        >
          Cancel
        </button>
        <button
          class="ml-4 rounded bg-gray-roc hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
          @click="save"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Artifacts from "@/roc/museum";
import MuseumListItem from "@/components/Museum/MuseumListItem.vue";
import {computed, onMounted, ref} from 'vue';
import {useMuseumStore} from '@/roc/stores/MuseumStore';
import ArtifactGroupType from '@/roc/museum/base/ArtifactGroupType';
import MuseumGroupItem from '@/components/Museum/MuseumGroupItem.vue';

export default {
  components: {
    MuseumGroupItem,
    MuseumListItem
  },
  setup () {
    const museumStore = useMuseumStore();
    
    const config = ref({});
    const loaded = ref(false);
    const selectedGroup = ref(ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION);

    onMounted(() => {
      for (const i in museumStore.artifacts) {
        config.value[i] = {
          ...museumStore.artifacts[i]
        };
      }

      loaded.value = true;
    });

    return {
      config,
      loaded,
      selectedGroup,

      allArtifacts: computed(() => {
        const r = [];

        for (let i = 0; i < Artifacts.length; i++) {
          if (selectedGroup.value === Artifacts[i].type) {
            r.push({
              id: Artifacts[i].id,
              name: Artifacts[i].name,
              icon: Artifacts[i].icon + '.png',
              groupIcon: Artifacts[i].groupIcon + '.png',
              power: Artifacts[i].power
            });
          }
        }

        return r;
      }),
      happinessEffect: computed(() => {
        return museumStore.calculateCultureBonus(config.value);
      }),
      groups: computed(() => {
        return museumStore.groupMap;
      }),

      save () {
        museumStore.setMuseumConfiguration(config.value);
        museumStore.closeMuseumConfiguration();
      },

      cancel () {
        museumStore.closeMuseumConfiguration();
      },

      toggleArtifactActive (id) {
        config.value[id].active = !config.value[id].active;
      },

      toggleAll () {
        for (const i in config.value) {
          config.value[i].active = !config.value[i].active;
        }
      },

      selectGroup (id) {
        selectedGroup.value = id;
      }
    };
  }
};
</script>

<style scoped>
.anim-t {
  transition: top 100ms ease-in-out;
}
</style>
